import React, { useEffect } from "react";

// This special setState hook can be used, if an event listener doesn't recognize a state change.
// The hook has a ref as a reference to the state value. Instead of the state, ref.current can be used.
export function useStateRef<T>(
  initialValue: T | (() => T)
): [T, React.Dispatch<React.SetStateAction<T>>, React.MutableRefObject<T>] {
  const [value, setValue] = React.useState(initialValue);

  const ref = React.useRef(value);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return [value, setValue, ref];
}

export const useTimeout = (callback: () => void, delay: number) => {
  const timerRef = React.useRef<number>();
  useEffect(() => {
    timerRef.current = window.setTimeout(callback, delay);
    return () => {
      // Unmount component
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);
};
